// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2Llrl","icon":"SortAdornment_icon__2Md6c","up":"SortAdornment_up__1b-KC","down":"SortAdornment_down__XLurZ","active":"SortAdornment_active__3T1CB"};